
import React, { createContext, useContext, useState, ReactNode } from "react";
import { AuthModal } from "./AuthModal";

interface AuthModalContextType {
    openAuthModal: () => void;
    closeAuthModal: () => void;
    isAuthModalOpen: boolean;
}

const AuthModalContext = createContext<AuthModalContextType | undefined>(undefined);

export function AuthModalProvider({ children }: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);

    const openAuthModal = () => setIsOpen(true);
    const closeAuthModal = () => setIsOpen(false);

    return (
        <AuthModalContext.Provider value={{ openAuthModal, closeAuthModal, isAuthModalOpen: isOpen }}>
            {children}
            <AuthModal isOpen={isOpen} onClose={closeAuthModal} />
        </AuthModalContext.Provider>
    );
}

export function useAuthModal() {
    const context = useContext(AuthModalContext);
    if (context === undefined) {
        throw new Error("useAuthModal must be used within an AuthModalProvider");
    }
    return context;
}
